import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@modulor/react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import withAnalytics from '../../../hocs/withAnalytics';
import { getDataTestAttrs } from '../../../utils/testing-locators';
import {
  NAVIGATION_MAIN_LINK,
  NAVIGATION_MAIN_LINK_ARROW,
  NAVIGATION_MAIN_LINK_ICON,
  NAVIGATION_MAIN_LINK_NAME,
} from '../../../constants/dataTestIds';
import { useIsDesktopLayout } from '../../../hooks/useMediaQuery';
import styles from './MainNavigationItem.module.css';

const MainNavigationItem = ({
  icon,
  className,
  children,
  activeOnRoutes,
  ...props
}) => {
  const isDesktop = useIsDesktopLayout();
  const { path } = useRouteMatch();
  return (
    <NavLink
      exact
      className={(isActive) =>
        classNames(
          styles.link,
          (isActive || activeOnRoutes?.includes(path)) && styles.active,
          className
        )
      }
      {...getDataTestAttrs(NAVIGATION_MAIN_LINK, props.to)}
      {...props}
    >
      <i
        className={styles.icon}
        {...getDataTestAttrs(NAVIGATION_MAIN_LINK_ICON)}
      >
        {icon}
      </i>
      <div
        className={styles.title}
        {...getDataTestAttrs(NAVIGATION_MAIN_LINK_NAME)}
      >
        {children}
      </div>
      {!isDesktop && (
        <Icon
          name="chevron_right"
          className={styles.arrow}
          {...getDataTestAttrs(NAVIGATION_MAIN_LINK_ARROW)}
        />
      )}
    </NavLink>
  );
};

MainNavigationItem.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
  activeOnRoutes: PropTypes.arrayOf(PropTypes.string),
};

MainNavigationItem.defaultProps = {
  activeOnRoutes: [],
};

export default MainNavigationItem;

export const MainNavigationItemWithAnalytics =
  withAnalytics(MainNavigationItem);
